<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item label="类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-select
            v-decorator="[
              'type',
              { rules: [{ required: true, message: '请选择类型' }] }
            ]"
            placeholder="请选择类型"
          >
            <a-select-option :value="1" :key="1">
              订阅号
            </a-select-option>
            <a-select-option :value="2" :key="2">
              服务号
            </a-select-option>
            <a-select-option :value="3" :key="3">
              小程序
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="名字" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            v-decorator="[
              'name',
              { rules: [{ required: true, message: '请输入名字' }] }
            ]"
            placeholder="请输入名字"
          ></a-input>
        </a-form-item>
        <a-form-item
          label="原始ID"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            v-decorator="[
              'sourceId',
              { rules: [{ required: true, message: '请输入原始ID' }] }
            ]"
            placeholder="请输入原始ID"
          ></a-input>
        </a-form-item>
        <a-form-item
          label="appId"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            v-decorator="[
              'appId',
              { rules: [{ required: true, message: '请输入appId' }] }
            ]"
            placeholder="请输入appId"
          ></a-input>
        </a-form-item>
        <a-form-item
          label="appSecret"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            v-decorator="[
              'appSecret',
              { rules: [{ required: true, message: '请输入appSecret' }] }
            ]"
            placeholder="请输入appSecret"
          ></a-input>
        </a-form-item>
        <a-form-item
          label="Token"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input v-decorator="['token']" placeholder="请输入Token"></a-input>
        </a-form-item>
        <a-form-item
          label="AESKey"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            v-decorator="['aesKey']"
            placeholder="请输入EncodingAESKey"
          ></a-input>
        </a-form-item>
        <a-form-item
          label="消息格式"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            v-decorator="[
              'msgFormat',
              { rules: [{ required: true, message: '请选择消息格式' }] }
            ]"
            placeholder="请选择消息格式"
          >
            <a-select-option :value="'xml'" :key="'xml'">
              XML
            </a-select-option>
            <a-select-option :value="'json'" :key="'json'">
              JSON
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          label="是否认证"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            v-decorator="[
              'verified',
              { rules: [{ required: true, message: '请选择是否认证' }] }
            ]"
            placeholder="请选择是否认证"
          >
            <a-select-option :value="1" :key="1">
              是
            </a-select-option>
            <a-select-option :value="0" :key="0">
              否
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="Icon" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-image-upload
            class="avatar-uploader"
            text="上传"
            v-model="model.iconList"
          ></j-image-upload>
        </a-form-item>
        <a-form-item label="状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-select
            v-decorator="[
              'status',
              { rules: [{ required: true, message: '请选择状态' }] }
            ]"
            placeholder="请选择状态"
          >
            <a-select-option :value="1" :key="1">
              正常
            </a-select-option>
            <a-select-option :value="0" :key="0">
              冻结
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-spin>
  </j-modal>
</template>

<script>
import { httpAction } from '@/api/manage';
import pick from 'lodash.pick';
import { validateDuplicateValue } from '@/utils/util';
import JDate from '@/components/jeecg/JDate';
import JImageUpload from '@/components/jeecg/JImageUpload';

export default {
  name: 'WechatAppModal',
  components: {
    JDate,
    JImageUpload
  },
  data() {
    return {
      form: this.$form.createForm(this),
      title: '操作',
      width: 800,
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      validatorRules: {},
      url: {
        add: process.env.VUE_APP_CMS_WECHAT + '/wechatApp/add',
        edit: process.env.VUE_APP_CMS_WECHAT + '/wechatApp/edit'
      }
    };
  },
  created() {},
  methods: {
    add() {
      this.edit({});
    },
    edit(record) {
      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;
      this.$nextTick(() => {
        this.form.setFieldsValue(
          pick(
            this.model,
            'name',
            'type',
            'sourceId',
            'token',
            'aesKey',
            'msgFormat',
            'status',
            'appId',
            'appSecret',
            'verified'
          )
        );
      });
    },
    close() {
      this.$emit('close');
      this.visible = false;
    },
    handleOk() {
      const that = this;
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          let httpurl = '';
          let method = '';
          if (!this.model.id) {
            httpurl += this.url.add;
            method = 'post';
          } else {
            httpurl += this.url.edit;
            method = 'post';
          }
          let formData = Object.assign(this.model, values);
          console.log('表单提交数据', formData);
          httpAction(httpurl, formData, method)
            .then(res => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            })
            .finally(() => {
              that.confirmLoading = false;
              that.close();
            });
        }
      });
    },
    handleCancel() {
      this.close();
    },
    popupCallback(row) {
      this.form.setFieldsValue(
        pick(
          row,
          'name',
          'type',
          'sourceId',
          'token',
          'aesKey',
          'msgFormat',
          'status',
          'delFlag',
          'appId',
          'appSecret',
          'verified'
        )
      );
    }
  }
};
</script>
